import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import * as React from "react";
import DashboardDailySheet from "./DashboardDailySheet";
import DashboardOrders from "./DashboardOrders";
import DashboardPayment from "./DashboardPayment";
import DashboardReports from "./DashboardReports";
import DashboardSupplier from "./DashboardSupplier";
import SalesReport from "../Reports/SalesReport";
import { useSelector } from "react-redux";

export default function Dashboard() {
    const role = useSelector((state) => state.currentUser.role);
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
<div>
          <Stack alignItems="center">
          <Grid item xs={12} md={6}>
{role=="cs" &&(
<TabContext value={value}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                  marginTop:3,
                }}
              >
        <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="Payment" value="1" />
            <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="Reports" value="2"  />
            <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="Sales" value="3"  />
          </TabList>
        </Box>
        <TabPanel value="1">
        <DashboardPayment />
        </TabPanel>
        <TabPanel value="2">
        <DashboardReports />
        </TabPanel>
        <TabPanel value="3">
        <SalesReport />
        </TabPanel>
      </TabContext>
      )}
{role!=="cs" &&(
          <TabContext value={value}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                  marginTop:3,
                }}
              >
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="Payment" value="1" />
            <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="Reports" value="2"  />
            <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="Orders" value="3" />
            <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="DSheet" value="4" />
              <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="Supplier" value="5" />
              <Tab 
              sx={{
                textAlign: "center", 
                fontSize: { xs: "10px", md: "inherit" }, 
                fontWeight:{xs:'bold',} 
              }}
              label="Sales" value="6" />
          </TabList>
        </Box>
        <TabPanel value="1">
        <DashboardPayment />
        </TabPanel>
        <TabPanel value="2">
        <DashboardReports />
        </TabPanel>
        <TabPanel value="3">
          <DashboardOrders />
        </TabPanel>
        <TabPanel value="4">
          <DashboardDailySheet />
        </TabPanel>
        <TabPanel value="5">
          <DashboardSupplier />
        </TabPanel>
        <TabPanel value="6">
          <SalesReport />
        </TabPanel>
      </TabContext>
      )}
      </Grid>
      </Stack>
    </div>
  );
}
